<div class="main-container">
  <div class="logo-img  d-flex align-items-center mx-auto ">
    <img src="assets/images/logo/Full_logo.svg" class="img-fluid" alt="">
  </div>
  <div class="stepper-container ">
    <mat-stepper class="mt-4 pt-xl-2" #stepper animationDuration="300" linear  class="{{ 'last-edited-step-' + stepper.selectedIndex }}">
      <mat-step [stepControl]="firstFormGroup">
        <div class="small-stepper mt-4  mt-xl-0">
          <form [formGroup]="firstFormGroup" class="text-center" (ngSubmit)="onFirstStepperSubmit()">
            <div class="">
              <label for="" class="mb-3 mb-xl-2">Customize your app in 1 minute</label>
              <input type="text" class="form-control" placeholder="{{'Company Name'|translate}}" formControlName="company_name">
              <mat-error *ngIf="isControlHasError('company_name','required',firstFormGroup)" class="text-start"> Company Name is required</mat-error>
            </div>
            <div class="mt-4 mt-lg-4 mb-xl-2">
              <label for="" class="mb-3 mb-xl-2">What's your role in the company?</label>
              <input type="text" class="form-control" placeholder="{{'Job Role' |translate}}" formControlName="company_user_role">
              <mat-error *ngIf="isControlHasError('company_user_role','required',firstFormGroup)" class="text-start">Role is required</mat-error>
            </div>
            <button mat-raised-button color="primary" matStepperNext class="auth-form-btn mt-4  mb-xl-5"  type="submit">Next</button>
          </form>
        </div>
      </mat-step>
      <mat-step [completed]="isSecondStepCompleted">
        <div class="item-container text-center small-stepper2 mt-4 mt-xl-0">
          <label for="" class="mb-4 mb-lg-4">How many employees do you have?*</label>
          <div class="employee-box ">
            <div class="box-item" *ngFor="let item of employeeNumber" (click)="onEmployeeNo(item)" style="position: relative;">
              <div class="sub-box-item"> {{item.size}}</div>
              <div [ngClass]="item.selected ? 'selected-new animate'  : 'd-none'"></div>
            </div>
          </div>
          <div class="text-center">
            <mat-error *ngIf="isSecondStepClicked && !isSecondStepCompleted && (empSize==''||empSize==undefined)">
              Please select no. of employees</mat-error>
          </div>
          <label for="" class="my-4 my-lg-4"> What is your business industry?*</label>
          <div class="employee-industry justify-content-center">
            <div class="buisness-box" *ngFor="let item of buisnessIndustry" (click)="onIndustrySelect(item)">
              <div class="b-img"><img [src]="item.img" class="img-fluid"> </div>
              <div class="b-txt">{{item.i_name}}</div>
              <div [ngClass]="item.selected ? 'selected-new animate' : 'd-none'"></div>
            </div>
          </div>
          <div class="text-center">
            <mat-error *ngIf="isSecondStepClicked && !isSecondStepCompleted && (bIndustry==''||bIndustry==undefined)">
              Please select industry</mat-error>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center pt-1 pt-lg-0">
          <button mat-stroked-button matStepperPrevious class="auth-form-btn outline-btn mt-4  mb-xl-5">Back</button>
          <button mat-raised-button color="primary" matStepperNext class="auth-form-btn  mt-4 mb-xl-5 ms-3"
            (click)="onSecondStepperSubmit()">Next</button>
        </div>
      </mat-step>
      <mat-step [completed]="isThirdStepCompleted">
        <div class="small-stepper3 mt-4 mt-xl-0">
          <div class="text-center"><label for="" class="mb-2">Let's add the right features to your app</label>
          </div>
          <div class="text-center"> <label for="" class="mb-1 mb-xl-3  new-label">Select your preferred features so we
              can customize the platform to your needs</label></div>
          <div class="feature-box d-flex flex-column" *ngFor="let item of featureArr">
            <div class="d-flex align-items-center mt-3 mb-1 t-box">
              <mat-checkbox name="agree" (change)="onCheckBoxValue(item,$event)" [checked]="item.all_feature" [(ngModel)]="item.all_feature" ngModel>
                <div class="text-wrap"> {{item.title}}</div>
            </mat-checkbox>
              <label for="" class="mb-0 mt-0 box-label">{{item.name}}</label>
            </div>
       
            <div class="employee-industry ">
              <div class="buisness-box" *ngFor="let items of item.features" (click)="onFeaturesClick(items,item)">
                <div class="b-img"><img [src]="items.f_img" class="img-fluid"> </div>
                <div class="b-txt">{{items.f_name}}</div>
                <div [ngClass]="items.selected ? 'selected-new animate' : 'd-none'"></div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <mat-error *ngIf="isThirdStepClicked && !isThirdStepCompleted"> Please select at least one feature</mat-error>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-xl-1 ">
          <button mat-stroked-button matStepperPrevious class="auth-form-btn outline-btn  mt-4">Back</button>
          <button mat-raised-button color="primary" matStepperNext class="auth-form-btn ms-3 mt-4"
            (click)="onThirdStepperSubmit()">Next</button>
        </div>
      </mat-step>
      <mat-step>
        <div class="small-stepper mt-3 mt-xl-0">
          <div class="text-center logo-label text-black mb-2"> Make it your own</div>
          <div class="text-center logo-small-label mb-3 mb-lg-5"> Insert your logo</div>
          <div class="drop-box m-auto">
            <ngx-dropzone (change)="onSelect($event)" class="drop-item" [multiple]="false"
              accept="image/jpeg,image/jpg,image/png">
              <ngx-dropzone-label>
                <div class="d-flex">
                  <div class="upload-img mr-2">
                    <img src="assets/images/icons/upload.svg" class="img-fluid">
                  </div>
                  <div>
                    <div>Click to Upload</div>
                    <div class="upload-text">Or just drag and drop</div>
                  </div>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
          </div>
          <div class="text-center logo-small-label mt-2 mb-1"> Change from the settings menu at any time</div>
          <div class="d-flex align-items-center justify-content-center">
            <button mat-stroked-button matStepperPrevious class="mt-4 auth-form-btn outline-btn">Back</button>
            <button mat-raised-button color="primary" matStepperNext class="auth-form-btn ms-3 mt-4">Next</button>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div class="small-stepper mt-3 mt-xl-0">
          <form class="text-center" [formGroup]="infoFormGroup" (ngSubmit)="onFifthStepperSubmit()">
            <div class="logo-label">Upload your information </div>
            <div class="row ">
              <div class="col-md-6 mt-3">
                <mat-select (selectionChange)="onCountrySelect($event)" class="form-control" formControlName="country" placeholder="Select Country">
                  <mat-option *ngFor="let country of countries"  [value]="country.isoCode"
                    >{{country.flag}} {{country.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('country','required',infoFormGroup)" class="text-start">
                   Country is required</mat-error>
              </div>
              <div class="col-md-6 mt-3">
                <mat-select (selectionChange)="onStatesSelect($event)" class="form-control" formControlName="state" placeholder="Select State">
                  <mat-option *ngFor="let state of states" [value]="state.isoCode">{{ state.name }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('currency','required',infoFormGroup)" class="text-start"> 
                  State is required</mat-error>
              </div>
            </div>
            <div class="row ">
              <div class="col-md-6 mt-3">
                <mat-select class="form-control" formControlName="city" placeholder="Select City">
                  <mat-option *ngFor="let city of cities"  [value]="city">{{ city }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('country','required',infoFormGroup)" class="text-start"> City is required</mat-error>
              </div>
              <div class="col-md-6 mt-3">
                <select name="euro" class="form-control" id=""  formControlName="currency" (change)="onStates($event)">
                  <option value="">Select your currency</option>
                  <option value="euro">Euro</option>
                </select>
                <mat-error *ngIf="isControlHasError('currency','required',infoFormGroup)" class="text-start"> Currency
                  is required</mat-error>
              </div>
            </div>
            <div class="form-input mt-3">
              <input type="tel" class="form-control" placeholder="+1 12345 67890" formControlName="phone_number">
              <img src="assets/images/icons/phone.svg" class="img-fluid material-icons">
            </div>
             <mat-error *ngIf="isControlHasError('phone_number','required',infoFormGroup)" class="text-start"> Phone Number is required</mat-error>
            <div class="form-input mt-3">
              <input type="text" class="form-control" placeholder="{{'Enter website URL' | translate}}"
                formControlName="website_url">
              <img src="assets/images/icons/website.png" class="img-fluid material-icons" alt="">
            </div>
            <mat-error *ngIf="isControlHasError('website_url','required',infoFormGroup)" class="text-start">URL is required</mat-error>
            <div class="form-input mt-3">
              <textarea name="" id="" cols="30" rows="4" class="form-control" placeholder="About us..."
                formControlName="about_us"></textarea>
              <img src="assets/images/icons/about_us.png" class="img-fluid material-icons" alt="">
            </div>
            <mat-error *ngIf="isControlHasError('about_us','required',infoFormGroup)" class="text-start">About us is required</mat-error>
          
            <div class="d-flex align-items-center justify-content-center">
              <button mat-stroked-button matStepperPrevious class=" mt-4 auth-form-btn outline-btn">Back</button>
              <button mat-raised-button color="primary" matStepperNext type="submit"
                class="auth-form-btn ms-3  mt-4 ">Submit</button>
            </div>
          </form>
        </div>
      </mat-step>
      <ng-template matStepperIcon="edit" let-index="index">
        <div class="step-number">{{ index + 1 }}</div>
      </ng-template>
    </mat-stepper>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>